<section class="tw-flex tw-flex-col tw-flex-wrap tw-justify-around tw-content-center tw-w-full tw-h-full {{customClass}}">
  <p class="tw-font-semibold tw-text-2xl" *ngIf="title" >{{ title | translate }}</p>

  <form [formGroup]="reasonForm">
    <section class="tw-flex tw-flex-col tw-justify-center tw-content-center tw-gap-5">
      <ng-container *ngFor="let reason of reasons">
        <div class="tw-flex tw-flex-col tw-items-start tw-relative tw-group">
          <div class="tw-relative tw-w-full">
            <label 
              class="tw-text-xl tw-flex tw-items-center tw-normal-case tw-w-full"
              [ngClass]="{'tw-opacity-50 tw-cursor-not-allowed': reason.disabled}">
              <input
                class="tw-mr-2 tw-border-2 tw-h-6 tw-w-6 tw-border-[#0F93CC]"
                type="radio"
                formControlName="reason"
                [value]="reason.id"
                [attr.disabled]="reason.disabled ? true : null"
                (click)="!reason.disabled && onInputClick(reason.id)"
              />
              <span class="tw-inline-flex tw-items-center">{{ reason.reason | translate }}</span>
              <div class="tw-ml-2 tw-px-4 tw-py-1 tw-rounded-xl tw-text-xs tw-font-semibold tw-flex !tw-text-[14px] tw-gap-1 !tw-bg-[hsl(147,100%,82%)] !tw-text-[hsl(147,45%,57%)]" *ngIf="reason.highlight">
                <span
                  class="tw-text-xs tw-font-semibold tw-flex !tw-text-[14px] tw-gap-1 !tw-bg-[hsl(147,100%,82%)] !tw-text-[hsl(147,45%,57%)]"
                  [mhTooltip]="tooltipHighlight ? (tooltipHighlight | translate) : null"
                  position="above">
                  {{ 'cases.detail_modal.recommended' | translate }}
                </span>
              </div>
            </label>
            <div *ngIf="reason.disabled && reason.tooltip" class="tw-absolute tw-inset-0 tw-z-[5]" style="pointer-events: auto; cursor: not-allowed;" (click)="$event.preventDefault(); $event.stopPropagation()"></div>
          </div>
          <p class="tw-text-sm tw-text-gray-500 tw-font-normal tw-leading-none tw-tracking-normal tw-ml-8">{{ reason.subtitle | translate: (reason.subtitleParams || {}) }}</p>
          <div *ngIf="reason.tooltip" 
               class="tw-absolute tw-left-0 tw-bottom-full tw-mb-2 tw-px-3 tw-py-2 tw-bg-gray-800 tw-text-white tw-text-sm tw-rounded-lg tw-opacity-0 tw-invisible group-hover:tw-opacity-100 group-hover:tw-visible tw-transition-all tw-duration-200 tw-z-[9999] pointer-events-none"
               [class.tw-whitespace-nowrap]="!reason.tooltipIsTranslated"
               [class.tw-whitespace-pre-line]="reason.tooltipIsTranslated">
            <span *ngIf="reason.tooltipIsTranslated">{{ reason.tooltip }}</span>
            <span *ngIf="!reason.tooltipIsTranslated">{{ reason.tooltip | translate }}</span>
            <div class="tw-absolute tw-left-4 tw-top-full tw-border-4 tw-border-transparent tw-border-t-gray-800"></div>
          </div>
          <div *ngIf="reason.childs && reason.childs.length > 0" class="tw-ml-8 tw-mt-2 tw-flex tw-flex-col tw-gap-2">
            <div *ngFor="let child of reason.childs" class="tw-flex tw-items-center">
              <input
                type="checkbox"
                [formControlName]="getChildControlName(reason.id, child.id)"
                [id]="'child_' + reason.id + '_' + child.id"
                class="tw-mr-2 tw-h-4 tw-w-4 tw-border-2 tw-border-gray-300 tw-rounded tw-text-[#0F93CC] focus:tw-ring-[#0F93CC]"
                (change)="onChildChange(reason.id, child.id, $event.target.checked)"
              />
              <label [for]="'child_' + reason.id + '_' + child.id" class="tw-text-sm tw-text-gray-700 tw-cursor-pointer">
                {{ child.text | translate }}
              </label>
            </div>
          </div>
        </div>
          <mh-core-lib-textarea-input
            class="tw-w-full"
            [placeholder]="'cases.detail_modal.insert_reason' | translate"
            [formGroup]="reasonForm"
            [keyControl]="'reasonComment'"
            [rows]="5"
            [inputClass]="'!tw-font-[Rubik] tw-border-gray-400 tw-resize-none'"
            [style.visibility]="currentOption !== 5 ? 'hidden' : 'visible'"
            *ngIf="reason.id === 5 && OtherOptionAvailable"
        ></mh-core-lib-textarea-input>
      </ng-container>
    </section>
  </form>

  <section class="tw-flex tw-gap-3 tw-justify-center" *ngIf="showButtons">
    <mh-core-lib-button
      [isSecondary]="true"
      [text]="'commons.cancel' | translate"
      [customClass]="'!tw-shadow-none !tw-px-2'"
      [textClass]="'tw-font-[Rubik] tw-text-sm'"
      (clicked)="cancelDiscard()"
    ></mh-core-lib-button>

    <mh-core-lib-button
      [isPrimary]="true"
      [isDisabled]="(currentOption === 5 && reasonForm.get('reasonComment').value?.length <= 5) || !reasonForm.get('reason').value"
      [text]="'cases.detail_modal.discard_case' | translate"
      [customClass]="'!tw-shadow-none !tw-px-2'"
      [textClass]="'tw-font-[Rubik] tw-text-sm'"
      (clicked)="discardCase()"
    ></mh-core-lib-button>
  </section>
</section>
